export default "__VITE_ASSET__DYOw6OSB__"